import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { FriendsPage } from './pages/FriendsPage';
import { StatusesPage } from './pages/StatusesPage';
import { InflowRoutesPage } from './pages/InflowRoutesPage';
import { TagsPage } from './pages/TagsPage';
import { isAuthenticated } from './lib/auth';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/friends"
          element={
            <ProtectedRoute>
              <FriendsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/statuses"
          element={
            <ProtectedRoute>
              <StatusesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/inflow-routes"
          element={
            <ProtectedRoute>
              <InflowRoutesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tags"
          element={
            <ProtectedRoute>
              <TagsPage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/friends" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
